'use client';

import { useEffect, useState } from 'react';

export const useSearchParams = (): URLSearchParams => {
  const [searchParams, setSearchParams] = useState<URLSearchParams>(() => {
    if (typeof window === 'undefined') {
      return new URLSearchParams();
    }
    return new URLSearchParams(window.location.search);
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setSearchParams(params);

    const handlePopState = () => {
      setSearchParams(new URLSearchParams(window.location.search));
    };

    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  return searchParams;
};
